module.exports = "<p>\n  tenant-signup works!\n</p>\n"